import React from 'react';
import { useTranslation } from 'react-i18next';
import './Illustrations.css';

/**
 * One paid invoice and one overdue invoice with a reminder button.
 * @returns {JSX.Element} Decorative drawing
 */
function InvoicesIllustration() {
  const { t } = useTranslation();

  return (
    <svg className="illustration" viewBox="0 0 320 220" aria-hidden="true" focusable="false">
      <rect className="ill-paper" x="32" y="34" width="232" height="62" rx="14" />
      <text className="ill-text ill-text-navy" x="54" y="70" fontSize="14">
        {t('illustrations.invoices.paidInvoice')}
      </text>
      <rect className="ill-green-soft" x="170" y="52" width="78" height="26" rx="13" />
      <text className="ill-text ill-text-green" x="209" y="69" fontSize="12" textAnchor="middle">
        {t('illustrations.invoices.paid')}
      </text>

      <rect className="ill-paper ill-paper-alert" x="52" y="114" width="240" height="76" rx="14" />
      <text className="ill-text ill-text-navy" x="74" y="146" fontSize="14">
        {t('illustrations.invoices.overdueInvoice')}
      </text>
      <text className="ill-text ill-text-orange" x="74" y="170" fontSize="12">
        {t('illustrations.invoices.overdue')}
      </text>
      <rect className="ill-orange" x="216" y="138" width="58" height="28" rx="14" />
      <text className="ill-text ill-text-white" x="245" y="156" fontSize="12" textAnchor="middle">
        {t('illustrations.invoices.remind')}
      </text>
    </svg>
  );
}

export default InvoicesIllustration;
